exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.CoverImage__carouselImageClassName___3lee1, div.CoverImage__carouselImageClassNameMobile___nXP84 {\n  vertical-align: top;\n  margin-top: -1px;\n  border-radius: 10px; }\n\ndiv.CoverImage__carouselImageClassName___3lee1 {\n  height: 220px; }\n\n.CoverImage__image___26PhO, .CoverImage__imageMobile___2LFnt {\n  border-radius: 10px;\n  display: inline-block; }\n\n.CoverImage__image___26PhO {\n  height: 220px; }\n\ndiv.CoverImage__carouselImageClassNameMobile___nXP84 {\n  height: 220px; }\n\n.CoverImage__imageMobile___2LFnt {\n  height: 220px; }\n", ""]);

// exports
exports.locals = {
	"carouselImageClassName": "CoverImage__carouselImageClassName___3lee1",
	"carouselImageClassNameMobile": "CoverImage__carouselImageClassNameMobile___nXP84",
	"image": "CoverImage__image___26PhO",
	"imageMobile": "CoverImage__imageMobile___2LFnt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SimilarAdCard/CoverImage/CoverImage.scss
// module id = 4145
// module chunks = 6